<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/solicitacao', query: $route.query }">
        Compras/ Solicitação
      </router-link>
      <label class="labelBar"> / </label>
      <label> Aprovar Solicitação </label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Unidade Administrativa"
              v-model="unidadeAdm"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Local de Entrega"
              v-model="local"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Solicitante"
              v-model="solicitante"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Prioridade"
              v-model="prioridade"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Nº Solicitação"
              v-model="solicitacao.id"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-textarea
              label="Observação"
              auto-grow
              v-model="observacao" v-uppercase
              rows="1"
              readonly
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea
              label="Observação do Aprovador"
              auto-grow
              v-model="observacaoAprovador"
              maxlength="200"
              counter
              rows="1"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="5000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>
      <v-card>
        <v-data-table :headers="headers" hide-default-footer :items-per-page="-1" :items="produtosL">
          <template v-slot:item.autorizado="{ item }">
            {{ item.quantidadeAutorizado > 0 ? "Sim" : "Não" }}
          </template>
          <template v-slot:item.quantidadeAutorizado="{ item }">
            <v-text-field
              v-model.number="item.quantidadeAutorizado"
              type="number"
              :rules="[
                (v) =>
                  validarQuantidadeAprovadaItem(item, v) ||
                  'A quantidade deve ser 0 até a quantidade requisitada!',
              ]"
              required
            >
            </v-text-field>
          </template>
        </v-data-table>
      </v-card>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn
            @click="desfazer"
            color="primary"
            class="mr-4"
            :disabled="solicitacao.status != 'AG'"
          >
            Desaprovar
          </v-btn>
          <v-btn
            @click="declinar"
            :disabled="(solicitacao.status == 7 && !isAdmin()) || !isInactive(idModulo)"
            color="secondary"
            class="mr-4"
          >
            Declinar
          </v-btn>
          <v-btn
            :to="{ path: '/solicitacao', query: $route.query }"
            color="error"
            class="mr-4"
          >
            Voltar
          </v-btn>
          <v-btn
            @click="aprovar"
            color="success"
            class="mr-4"
            :disabled="
              (solicitacao.status != 'AA' && solicitacao.status != 'D') ||
              !isApproving(idModulo)
            "
          >
            Aprovar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import {
  aprovarSolicitacaoAsync,
  declinarSolicitacaoAsync,
  desautorizarSolicitacaoAsync,
  obterSolicitacoesAsync,
} from "../../../services/solicitacaoService";
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  getUserRoles,
  isLoggedUserAdmin,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";

export default {
  name: "aprovarSolicitacao",
  data: () => ({
    idModulo: 9,
    prioridade: null,
    overlay: false,
    valid: true,
    id: null,
    requisitante: null,
    idOrdemServico: null,
    descricao: null,
    observacao: null,
    observacaoAprovador: null,
    autorizado: null,
    local: null,
    unidadeAdm: null,
    produtosL: [],
    indexEdit: null,
    errorMessage: false,
    errorMessageValue: null,
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Item", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Qtd.", value: "quantidade", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      {
        text: "Qtd. Aprv.",
        value: "quantidadeAutorizado",
        width: "10%",
      },
      { text: "Aprov.?", value: "autorizado", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("solicitacao", ["solicitacao"]),
  },
  methods: {
    ...mapActions("solicitacao", ["updateSolicitacao"]),
    isApproving(id) {
      const pode = canApproveModule(id);
      logApprovalDiagnostics("Solicitacao/Aprovar:Aprovar", explainApprovalButtonState({
        modulo: id,
        registro: this.solicitacao,
        action: "aprovar",
        statusPermitidos: ["AA"],
      }));
      return pode;
    },
    isInactive(id) {
      const pode = canDeclineModule(id);
      logApprovalDiagnostics("Solicitacao/Aprovar:Declinar", explainApprovalButtonState({
        modulo: id,
        registro: this.solicitacao,
        action: "declinar",
        statusPermitidos: ["AA", "AG", "D"],
      }));
      return pode;
    },
    isAdmin() {
      return isLoggedUserAdmin();
    },
    async aprovar() {
      if (this.$refs.form.validate()) {
        await this.carregarItensPersistidos();
        const produtos = this.produtosL.map(this.normalizarItemAprovacao);

        for (var i = 0; i < produtos.length; i++) {
          if (!this.validarQuantidadeAprovadaItem(produtos[i])) {
            this.errorMessageValue =
              "A quantidade deve ser entre 0 até a mesma quantidade requisitada!";
            this.errorMessage = true;
            break;
          }
        }
        if (this.errorMessage) {
          return;
        }
        this.errorMessage = true;
        this.errorMessageValue =
          "A quantidade de pelo menos 1 dos items deve ser maior que zero!";
        for (var j = 0; j < produtos.length; j++) {
          if (produtos[j].quantidadeAutorizado > 0) {
            this.errorMessage = false;
            break;
          }
        }
        if (this.errorMessage) {
          return;
        }
        this.overlay = true;
        try {
          const resposta = await aprovarSolicitacaoAsync(
            this.solicitacao.id,
            this.observacaoAprovador,
            produtos
          );
          if (!resposta || resposta?.status != 200) {
            //this.mensagemErro = resposta;
            //this.mostartMensagemErro = true;
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateSolicitacao(this.mountObjSolicitacao(resposta.data));
            this.$store.dispatch("ui/showSnackbar", {
              text: "Solicitação aprovada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/solicitacao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      }
    },

    async declinar() {
      try {
        await this.$confirm(
          "Tem certeza que deseja declinar os itens? Todos serão cancelados.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        this.overlay = true;
        try {
          const resposta = await declinarSolicitacaoAsync(
            this.solicitacao.id,
            this.observacaoAprovador
          );
          if (!resposta || resposta?.status != 200) {
            this.overlay = false;
            this.$alert(
              resposta.message,
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.updateSolicitacao(this.mountObjSolicitacao(null));
            this.overlay = false;
            this.$store.dispatch("ui/showSnackbar", {
              text: "Solicitação declinada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/solicitacao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } catch {
        return;
      }
    },
    async desfazer() {
      try {
        await this.$confirm(
          "Tem certeza que deseja desaprovar os itens? Os mesmos voltaram para o status inicial de “Aguardando autorização”.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        for (var i = 0; i < this.produtosL.length; i++) {
          this.produtosL[i].quantidadeAutorizado = 0;
        }
        this.observacaoAprovador = null;
        this.overlay = true;
        try {
          const resposta = await desautorizarSolicitacaoAsync(
            this.solicitacao.id,
            this.observacaoAprovador,
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.overlay = false;
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateSolicitacao(this.mountObjSolicitacao(resposta.data));
            this.overlay = false;
            this.$store.dispatch("ui/showSnackbar", {
              text: "Solicitação desaprovada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/solicitacao",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } catch {
        return;
      }
    },

    mountObjSolicitacao(obj) {
      return {
        ...this.solicitacao,
        status: obj == null ? "D" : obj.status,
        produtos: this.produtosL,
        observacaoAutorizador: this.observacaoAprovador,
      };
    },
    obterQuantidadeAprovadaInicial(item) {
      if (this.solicitacao.status === "AA" || this.solicitacao.status === "D") {
        return Number(item.quantidade) || 0;
      }

      const quantidadeAutorizado = Number(item.quantidadeAutorizado);

      if (
        item.quantidadeAutorizado !== null &&
        item.quantidadeAutorizado !== undefined &&
        item.quantidadeAutorizado !== "" &&
        Number.isFinite(quantidadeAutorizado)
      ) {
        return quantidadeAutorizado;
      }

      return Number(item.quantidade) || 0;
    },
    async carregarItensPersistidos() {
      if (!this.produtosL.some((item) => !item.id || item.id <= 0)) {
        return;
      }

      const solicitacoes = await obterSolicitacoesAsync();
      const solicitacaoPersistida = solicitacoes.find(
        (item) => item.id === this.solicitacao.id
      );

      if (
        !solicitacaoPersistida ||
        !solicitacaoPersistida.produtos ||
        solicitacaoPersistida.produtos.length !== this.produtosL.length
      ) {
        return;
      }

      for (var i = 0; i < this.produtosL.length; i++) {
        this.$set(this.produtosL[i], "id", solicitacaoPersistida.produtos[i].id);
        this.$set(
          this.produtosL[i],
          "idSolicitacao",
          solicitacaoPersistida.produtos[i].idSolicitacao
        );
      }
    },
    normalizarItemAprovacao(item) {
      const quantidade = Number(item.quantidade) || 0;
      const quantidadeAutorizado = Number(item.quantidadeAutorizado);
      const quantidadeAprovada = Number.isFinite(quantidadeAutorizado)
        ? quantidadeAutorizado
        : quantidade;

      return {
        id: item.id,
        idSolicitacao: item.idSolicitacao,
        idProduto: item.idProduto,
        idCentroCusto: item.idCentroCusto,
        quantidade,
        quantidadeAutorizado: quantidadeAprovada,
        autorizado: quantidadeAprovada > 0,
      };
    },
    validarQuantidadeAprovadaItem(item, valor = item.quantidadeAutorizado) {
      const quantidadeSolicitada = Number(item.quantidade);
      const quantidadeAprovada = Number(valor);

      return (
        Number.isFinite(quantidadeSolicitada) &&
        Number.isFinite(quantidadeAprovada) &&
        quantidadeAprovada >= 0 &&
        quantidadeAprovada <= quantidadeSolicitada
      );
    },
  },
  created: function () {
    var index = 0;
    this.prioridade =
      this.solicitacao.prioridade == 1 ? "Normal" : "Emergencial";
    this.id = this.solicitacao.id;
    this.solicitante = this.solicitacao.solicitante;
    this.produtosL = JSON.parse(JSON.stringify(this.solicitacao.produtos || []));
    this.autorizado = this.solicitacao.autorizado;
    this.unidadeAdm = this.solicitacao.unidadeAdm;
    this.local = this.solicitacao.local;
    this.observacao = this.solicitacao.observacao;
    this.observacaoAprovador = this.solicitacao.observacaoAutorizador;

    for (var i = 0; i < this.produtosL.length; i++) {
      this.$set(this.produtosL[i], "index", index++);
      this.$set(
        this.produtosL[i],
        "quantidadeAutorizado",
        this.obterQuantidadeAprovadaInicial(this.produtosL[i])
      );
    }
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
